import { Record } from "immutable";

import { CLEANING_FREQUENCY } from "@typings/booking";
import { Subscription } from "@typings/subscription";

export const subscriptionFactory = (
  subscription: Subscription,
): Record<Subscription> => {
  const initialState: Subscription = {
    uuid: "",
    frequency: CLEANING_FREQUENCY.WEEKLY,
    pricePlanUuid: "",
    usePriceForOnceCleaning: false,
    freeCancellationsTotal: 0,
    freeCancellationsUsed: 0,
    endDate: "",
    startDate: "",
    name: "",
    pricePerHour: "",
    currency: "",
    serviceLocationId: 0,
  };

  return Record(initialState)(subscription);
};
